import { useRef } from 'react';
import useSWR from 'swr';
import type { SwrReturnType } from '~/models/Api';
import type { DealInspectionReportImage } from '~/models/DealReportImage';
import { generatePath } from '~/utils/generatePath';

type TIndex = (id: number | null) => SwrReturnType<DealInspectionReportImage[]>;
type ReturnType = {
  index: TIndex;
};

export const useDealInspectionReportImages = (): ReturnType => {
  const cachedDataRef = useRef<DealInspectionReportImage[] | null>(null);

  const index: TIndex = (dealId: number | null) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data, mutate, error } = useSWR<DealInspectionReportImage[]>(
      dealId === null
        ? null
        : generatePath('/deals/:deal_id/deal_inspection_report_images', {
            deal_id: dealId
          })
    );

    if (data) {
      cachedDataRef.current = data;
    }

    return {
      data: data ?? cachedDataRef.current,
      mutate,
      isLoading: !data && !error,
      error
    };
  };
  return { index };
};
